var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearSkyDayX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5708_3188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17V19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19V17C14.7614 17 17 14.7614 17 12Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 23V21C11 20.4477 11.4477 20 12 20C12.5523 20 13 20.4477 13 21V23C13 23.5523 12.5523 24 12 24C11.4477 24 11 23.5523 11 23Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 3V1C11 0.447715 11.4477 0 12 0C12.5523 0 13 0.447715 13 1V3C13 3.55228 12.5523 4 12 4C11.4477 4 11 3.55228 11 3Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 11H3C3.55228 11 4 11.4477 4 12C4 12.5523 3.55228 13 3 13H1C0.447715 13 -2.41411e-08 12.5523 0 12C2.41411e-08 11.4477 0.447715 11 1 11Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 11H23C23.5523 11 24 11.4477 24 12C24 12.5523 23.5523 13 23 13H21C20.4477 13 20 12.5523 20 12C20 11.4477 20.4477 11 21 11Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.92893 3.51472L6.34314 4.92893C6.73366 5.31946 6.73366 5.95262 6.34314 6.34315C5.95261 6.73367 5.31945 6.73367 4.92893 6.34315L3.51471 4.92893C3.12419 4.53841 3.12419 3.90524 3.51471 3.51472C3.90524 3.1242 4.5384 3.1242 4.92893 3.51472Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0711 17.6569L20.4853 19.0711C20.8758 19.4616 20.8758 20.0948 20.4853 20.4853C20.0947 20.8758 19.4616 20.8758 19.0711 20.4853L17.6568 19.0711C17.2663 18.6805 17.2663 18.0474 17.6568 17.6569C18.0474 17.2663 18.6805 17.2663 19.0711 17.6569Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4853 4.92893L19.0711 6.34314C18.6805 6.73367 18.0474 6.73367 17.6568 6.34314C17.2663 5.95262 17.2663 5.31945 17.6568 4.92893L19.0711 3.51472C19.4616 3.12419 20.0947 3.12419 20.4853 3.51472C20.8758 3.90524 20.8758 4.5384 20.4853 4.92893Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34314 19.0711L4.92892 20.4853C4.5384 20.8758 3.90523 20.8758 3.51471 20.4853C3.12419 20.0948 3.12419 19.4616 3.51471 19.0711L4.92892 17.6569C5.31945 17.2663 5.95261 17.2663 6.34314 17.6569C6.73366 18.0474 6.73366 18.6805 6.34314 19.0711Z",
    fill: "#263238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5708_3188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearSkyDayX2);
export default __webpack_public_path__ + "static/media/ClearSkyDayX2.23594e1d6af10a28b8243c017379dbfe.svg";
export { ForwardRef as ReactComponent };